import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(4),
    },
  },
  card: {
    height: '100%',
  },
  cardActionArea: {
    height: '100%',
  },
  cardContent: {
    height: 'calc(100% - 192px)',
  },
  description: {
    color: 'rgba(0, 0, 0, 0.7)',
    lineHeight: '1.25em',
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(-2),
  },
}))
